<!-- Header Section -->
<nav class="navbar navbar-expand-lg navbar-light header" *ngIf="showHeaderFooter">
  <div class="container-fluid">
    <a class="navbar-brand" [routerLink]="['/']">
      <img src="assets/images/mainLogo.png" class="main-logo" alt="logo" />
    </a>
    <div *ngIf="isLoggedIn">
      <div class="flex items-center gap-2 mr-auto">
        <div
          class="w-auto text-sm text-green-700 bg-green-50 border-green-700 px-2 py-1 rounded-full text-center font-medium border border-solid mr-4"
        >
          Credits: <b>{{ credits }}</b>
        </div>
        <ul class="navbar-nav mr-auto nav-links" id="navbar-nav-tour">
          <li id="nav-item-1" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
            <a [routerLink]="['/']" (click)="closeMobileHeader()">Home</a>
          </li>
          <li id="nav-item-2" routerLinkActive="active">
            <a [routerLink]="['/report-history']">Report History</a>
          </li>
        </ul>

        <div class="dropdown border-l border-gray-200 pl-4">
          <button
            class="dropdown-toggle userProfile-dropdown"
            type="button"
            id="dropdownMenuButton1"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <ng-container *ngIf="userDetails?.profileImg; else defaultProfileImage">
              <img
                [src]="userDetails?.profileImg"
                class="rounded-full"
                width="36"
                height="36"
                alt="User Profile"
              />
            </ng-container>
            <ng-template #defaultProfileImage>
              <div
                class="flex items-center justify-center w-10 h-10 bg-gray-200 rounded-full text-lg font-semibold"
              >
                {{ userInitial }}
              </div>
            </ng-template>
          </button>
          <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            <li>
              <a [routerLink]="['/user/profile']" (click)="closeMobileHeader()">
                <mat-icon class="text-gray-500">person</mat-icon> My Profile</a
              >
            </li>
            <li class="cursor-pointer">
              <a (click)="logout()"> <mat-icon class="text-gray-500">logout</mat-icon> Logout </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div *ngIf="!isLoggedIn">
      <div class="flex items-center gap-2">
        <app-common-button
          text="Login"
          variant="outline"
          [routerLink]="['/auth/login']"
        ></app-common-button>
        <app-common-button
          text="Sign up"
          variant="primary"
          [routerLink]="['/auth/signup']"
        ></app-common-button>
      </div>
    </div>
  </div>
</nav>

<router-outlet></router-outlet>

<!-- Footer -->
<footer class="w-full bg-radar-primary py-6" [ngClass]="{ 'pt-24': !isLoggedIn }">
  <div class="max-w-[1512px] mx-auto px-4 sm:px-8 lg:px-20">
    <div class="flex flex-col md:flex-row justify-between items-start gap-8 mb-8">
      <div class="flex flex-col gap-3">
        <p class="text-white text-xs font-medium leading-[110%] tracking-[0.048px] mb-0">
          Powered by
        </p>
        <img
          src="assets/images/dhwani-white-logo.png"
          alt="Dhwani Logo"
          class="h-[41px] w-auto object-contain"
        />
      </div>
    </div>

    <div
      class="border-t border-white/20 pt-5 flex flex-col md:flex-row justify-between items-center gap-4"
    >
      <p class="text-white text-sm font-normal leading-[110%] tracking-[0.035px]">
        © 2025 All rights reserved
      </p>
      <div
        class="flex items-center gap-6 text-white text-sm font-normal leading-[110%] tracking-[0.035px]"
      >
        <a href="/terms" class="hover:opacity-80 transition-opacity"> Terms of Service </a>
        <a href="/privacy" class="hover:opacity-80 transition-opacity"> Privacy Policy </a>
      </div>
    </div>
  </div>
</footer>
